import { Component, EventEmitter, AfterViewInit } from '@angular/core';
import { Input } from '@angular/core';
import { BentoComboboxOptions, BentoComboboxSearchEvent } from '@bento/bento-ng';

@Component({
	selector: 'app-bento-combobox-ng',
	templateUrl: './bento-combobox-ng.component.html',
	styleUrls: ['./bento-combobox-ng.component.css']
})
export class BentoComboboxNgComponent implements AfterViewInit {
	dataEmitter: EventEmitter<any> = new EventEmitter();
	selectedRow: any;
	@Input() data: any;
	options: BentoComboboxOptions = {
		searchable: true
	};

	private blockSize = 12;
	constructor() { }

	ngAfterViewInit() {
		setTimeout(() => {
			// Simulate initial server load with 100ms delay
			this.dataEmitter.emit(this.getData(0, this.blockSize));
		}, 100);
	}
	getData(index, size) {
		if (index >= this.data.length) {
			// the index exceeds the size of data
			return [];
		}

		return this.data.slice(index, index + size);
	}

	onEndOfScroll(e: BentoComboboxSearchEvent) {
		if (e.search) {
			// We ignore infinite scroll for search in this demo
			// Feel free to include your custom paginated server search results here
		} else {
			const nextBlock = this.getData(e.currentIndex, this.blockSize);
			if (nextBlock.length > 0) {
				setTimeout(() => {
					this.dataEmitter.emit(nextBlock);
				});
			}
		}
	}

}
